import { Component, Input } from '@angular/core';
import { ItemAttributesService } from '../services/item-attributes.service';
import { ItemAttributesStoreService } from './item-attributes-store.service';
import { UserIdToNamePipe } from '../pipes/user-id-to-name.pipe';
import { EditAttributeComponent } from './edit-attribute/edit-attribute.component';
import { UpdateAttributeValueComponent } from './update-attribute-value/update-attribute-value.component';
import { AddAttributeComponent } from './add-attribute/add-attribute.component';
import { AttributeListComponent } from './attribute-list/attribute-list.component';
import { NgSwitch, NgSwitchCase, AsyncPipe } from '@angular/common';
import { TestIdDirective } from '../directives/test-id.directive';

@Component({
    selector: 'app-item-attributes',
    templateUrl: './item-attributes.component.html',
    providers: [
        ItemAttributesService,
        ItemAttributesStoreService,
        UserIdToNamePipe
    ],
    standalone: true,
    imports: [TestIdDirective, NgSwitch, NgSwitchCase, AttributeListComponent, AddAttributeComponent, UpdateAttributeValueComponent, EditAttributeComponent, AsyncPipe]
})
export class ItemAttributesComponent {
  @Input() set itemId(value: number) {
    this.store.setItemIdAndLoadAttributes(value);
  }

  view$ = this.store.view$;

  constructor(private store: ItemAttributesStoreService) {}
}
